export default __webpack_public_path__ + "static/media/checkoutProduct.7d623e51.svg";